import Footer from "../components/footer/footer";
import Navbar from "../components/navbar/navbar";
// import MissionVision from "../components/servicecomponent/missionvision";
import Header from "./../components/servicecomponent/header";
// import Service from "../components/homecomponents/serviceslide";
// import Principles from "./../components/servicecomponent/principles";
// import Principle from "./../components/servicecomponent/principle";
// import Servicelist from "../components/servicecomponent/serviceslide";
// import Slide2 from "./../components/servicecomponent/slide2";
import Service1 from "./../components/servicecomponent/service1";
import Service2 from "./../components/servicecomponent/service2";
import Service3 from "./../components/servicecomponent/service3";
import Service4 from "./../components/servicecomponent/service4";
import Newsletter from "./../components/homecomponents/newsletter3";
// import Team from "./../components/contactcomponents/newteam";
import Image3 from "./../components/servicecomponent/imagestyle";


const Servicepage = () => {
    return(
        <div>
            <Navbar/>
            <Header/>
            <Service1/>
            <Service2/>
            <Service3/>
            <Service4/>
            {/* <Team/> */}
          
            {/* <Slide2/> */}
            {/* <MissionVision/> */}
            {/* <Principles/> */}
            {/* <Principle/> */}
            {/* <Image3/> */}
            
            <Newsletter/>
            <Footer/>

        </div>
    )
}
export default Servicepage;